import React from "react";

import { Row, Col, Select } from "antd";
import IntlMessages from "../../../../layout/components/lang/IntlMessages";

import { FileXls } from "phosphor-react";
import { useLocation, Link } from "react-router-dom";

const { Option } = Select;

export default function HistoryCard(props) {
  const formatPrice = (price) => {
    if (!price) return "R$ 0,00";

    // Remove o "R$ " se existir e converte para número
    const numericValue = parseFloat(price.toString().replace("R$ ", "").trim());

    // Formata como moeda brasileira
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  return (
    <>
      <Row gutter={[0, 16]} align="middle" justify="space-between">
        <Col sm={12} span={24}>
          <span className="h3 hp-font-weight-700 hp-text-color-black-bg hp-text-color-dark-0 hp-d-block">
            <IntlMessages id="history-historical" />
          </span>
        </Col>

        <Col>
          <Link
            to="/main/dashboard/nfes"
            className="hp-d-block hp-p1-body hp-font-weight-500 hp-text-color-black-bg hp-text-color-dark-0"
          >
            ver todas
          </Link>
        </Col>
      </Row>

      {props.list && (
        <Row gutter={[12, 12]} className="hp-mt-24">
          {props.list.map((item, index) => (
            <Col
              key={index}
              span={24}
              className="hp-bg-black-0 hp-bg-dark-100 hp-border-radius-lx hp-border-1 hp-border-color-black-10 hp-border-color-dark-80 hp-p-12"
            >
              <Row align="middle" justify="space-between">
                <Col sm={12} span={24} className="hp-mb-sm-16">
                  <Row align="middle" wrap={false}>
                    {item.fileXml && (
                      <Col>
                        <div
                          className="hp-cursor-pointer hp-text-color-primary-1 hp-mr-16"
                          style={{ fontSize: 32 }}
                        >
                          <Link to={`/main/dashboard/nfes/detail/${item.id}`}>
                            <FileXls size={32} />
                          </Link>
                        </div>
                      </Col>
                    )}

                    <Col>
                      {item.name && (
                        <span className="hp-d-block hp-p3-body hp-font-weight-700 hp-text-color-dark-10">
                          {item.name}
                        </span>
                      )}

                      {item.title && (
                        <span className="hp-d-block hp-p1-body">
                          {item.title}
                        </span>
                      )}
                    </Col>
                  </Row>
                </Col>

                <Col
                  sm={6}
                  span={12}
                  className="hp-text-sm-left hp-text-right"
                  style={{ minHeight: 50 }}
                >
                  {item.price && (
                    <span className="hp-d-block hp-p3-body hp-font-weight-400 hp-slashed-zero hp-text-color-dark-10">
                      {formatPrice(item.price)}
                    </span>
                  )}

                  {item.number && (
                    <span className="hp-d-block hp-p1-body hp-mt-4 hp-slashed-zero">
                      {item.number}
                    </span>
                  )}
                </Col>

                <Col
                  sm={6}
                  span={12}
                  className="hp-text-right"
                  style={{ minHeight: 50 }}
                >
                  {item.version && (
                    <span className="h4 hp-slashed-zero">{item.version}</span>
                  )}
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      )}
    </>
  );
}
